var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("h3", [_vm._v(_vm._s(_vm.header))]),
    _c("p", [_vm._v(_vm._s(_vm.message))]),
    _vm._m(0),
    _c("div", { staticClass: "buttons is-centered" }, [
      _c(
        "button",
        { staticClass: "button is-dark", on: { click: _vm.cancel } },
        [_vm._v("Cancel")]
      ),
      _c(
        "button",
        { staticClass: "button is-primary", on: { click: _vm.confirm } },
        [_vm._v(" " + _vm._s(_vm.cta) + " ")]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "warning" }, [
      _c("img", { attrs: { src: "/img/warning.png", alt: "warning" } })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }